import { LModalContentsWidthType, ModalType } from '@lib/components';
import { ModalBlockParts } from '@lib/services';
import { LinkedModalComponent } from './linked-modal.component';
export interface LinkedPayload {}
export function linkedPayloadParts(): ModalBlockParts {
  return {
    id: 'linked-modal',
    block: LinkedModalComponent,
    closeBackEnable: false,
    type: ModalType.TYPE10,
    modalWidth: LModalContentsWidthType.NONE,
    payload: {} as LinkedPayload,
  };
}
